<template>
    <div>
        <slot></slot>
        <b-modal
            :visible="show"
            :ok-title="okTitle"
            :cancel-title="cancelTitle"
            no-close-on-backdrop
            @ok="handleOk"
            @cancel="$emit('cancel')"
            v-bind="$attrs"
            ref="modal"
        >
            <slot name="title">
                <div slot="modal-title" v-html="title"></div>
            </slot>
            <slot name="text">
                <div v-html="text"></div>
            </slot>
            <template slot="modal-footer">
                <slot name="modal-footer" :handle-ok="handleOk" :handle-cancel="handleCancel"></slot>
            </template>
        </b-modal>
    </div>
</template>

<script>
import {BModal} from 'bootstrap-vue';

export default {
        components: {
            BModal,
        },
        props: {
            text: {
                type: String,
                default: 'Êtes-vous sûr de vouloir effectuer cette action ?'
            },
            title: {
                type: String,
                default: 'Confirmation'
            },
            okTitle: {
                type: String,
                default: 'Ok'
            },
            cancelTitle: {
                type: String,
                default: 'Annuler'
            },
            trigger: {
                type: Boolean,
                default: true
            },
            show: Boolean
        },

        data() {
            return {
                element: null,
                isOk : false,
            }
        },
        computed: {
            listenerMap() {
                return {
                    form: 'submit',
                    a: 'click'
                }
            }
        },

        methods: {
            onElementEvent(e) {
                if(!this.isOk) {
                    e.preventDefault();
                    this.$refs.modal.show();
                }
            },
            handleOk() {
                this.$emit('ok', this.element);
                this.isOk = true;
                const tag = this.element.tagName.toLowerCase();
                const event = this.listenerMap[tag];
                if(event && this.trigger) {
                    this.element[event]();
                }
                this.isOk = false;
            },
            handleCancel() {
                this.$refs.modal.hide();
            }
        },

        mounted() {
            this.element = this.$el.querySelector('a, form');
            const tag = this.element.tagName.toLowerCase();
            const event = this.listenerMap[tag];
            if(event) {
                this.element.addEventListener(event, this.onElementEvent);
            }
            else {
                console.error("Can't prevent event for element : ", this.element);
            }
        }
    }
</script>
